import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	year: number;
	previousEnabled: boolean;
	nextEnabled: boolean;
	onYearChange: (year: number) => void;
};

export const FlatRowDatePanelYearHeader = ({
	year,
	previousEnabled,
	nextEnabled,
	onYearChange,
}: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	const handlePrevious = () => {
		if (!previousEnabled) return;
		onYearChange(year - 1);
	};

	const handleNext = () => {
		if (!nextEnabled) return;
		onYearChange(year + 1);
	};

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			px={theme.spacingTokens.lg}
			pb={theme.spacingTokens.md}
		>
			<ButtonBase
				onClick={handlePrevious}
				aria-disabled={!previousEnabled}
				aria-label={t(Resources.Common.DatePicker.previousYear)}
				sx={{ p: theme.spacingTokens.sm, borderRadius: theme.radii.full }}
			>
				<ChevronLeft
					size={theme.iconSize.md}
					color={
						previousEnabled ? theme.palette.blue[600] : theme.palette.grey[300]
					}
				/>
			</ButtonBase>
			<Typography
				variant="bodyMedium"
				color={theme.palette.grey[800]}
				sx={{ fontVariantNumeric: "tabular-nums" }}
			>
				{year}
			</Typography>
			<ButtonBase
				onClick={handleNext}
				aria-disabled={!nextEnabled}
				aria-label={t(Resources.Common.DatePicker.nextYear)}
				sx={{ p: theme.spacingTokens.sm, borderRadius: theme.radii.full }}
			>
				<ChevronRight
					size={theme.iconSize.md}
					color={
						nextEnabled ? theme.palette.blue[600] : theme.palette.grey[300]
					}
				/>
			</ButtonBase>
		</Stack>
	);
};
